import {
  Component,
  OnInit,
  ViewEncapsulation,
  HostListener,
  EventEmitter,
  Input,
  Output,
  OnDestroy} from '@angular/core';
import { LecturesService, IListMeta } from '../providers/lectures.service';
import { VicarService               } from '../providers/vicar.service';
import { CurchService               } from '../providers/church.service';
import { OrganistService            } from '../providers/organist.service';
import { TimeService                } from '../providers/time.service';
import { Observable                 } from 'rxjs/Observable';
import {
  IDay,
  IPreacher,
  IChurch,
  IOrganist                         } from '../providers/interfaces';
import { IPlayEvent                 } from '../lecture-list-item/lecture-list-item.component';
import * as _ from 'lodash';
import { map, takeUntil, tap, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { Subject } from 'rxjs/Subject';

@Component({
  selector: 'app-history-list',
  templateUrl: './history-list.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./history-list.component.scss']
})
export class HistoryListComponent implements OnInit, OnDestroy {

  public days$: Observable<IDay[]>;
  public meta$: Observable<IListMeta>;
  public vicars$: Observable<IPreacher[]>;
  public preachers: IPreacher[];
  public curches$: Observable<IChurch[]>;
  public organists$: Observable<IOrganist[]>;
  public years$: Observable<number[]>;

  public page = 1;
  public pageSize = 4;
  public startDate = new Date( 0 );
  public endDate = new Date();
  public list: IDay[] = [];
  public currentService: number;

  public selectedReferent = null;
  public selectedChurch = null;
  public selectedOrganist = null;
  public selectedYear = null;

  vicarControl = new FormControl();
  filteredOptions: Observable<IPreacher[]>;
  destroy$ = new Subject();

  constructor(
    private $lectureService: LecturesService,
    private $vicarService: VicarService,
    private $churchService: CurchService,
    private $organistService: OrganistService,
    private $timeService: TimeService
  ) {

    this.days$ =      this.$lectureService.selectDaysAllFetch();
    this.meta$ =      this.$lectureService.meta$.asObservable();
    this.vicars$ =    this.$vicarService.selectVicarsAllFetch();
    this.curches$ =   this.$churchService.selectChurchesAllFetch();
    this.organists$ = this.$organistService.selectOrganistsAllFetch();
    this.years$ =     this.$timeService.selectYearsFetchAll();

    this.$vicarService.dispatchVicarsAllFetch();
    this.$churchService.dispatchChurchesAllFetch();
    this.$organistService.dispatchOrganistsAllFetch();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
  }

  ngOnInit() {
    console.log( '[DAY-LIST]: Init' );

    this.fetch();

    this.vicars$.pipe(
      takeUntil( this.destroy$ )
    ).subscribe( ( preachers ) => {
      this.preachers = preachers;
      this.filteredOptions = this.vicarControl.valueChanges.pipe(
        startWith<string | IPreacher>(''),
        map( value => typeof value === 'string' ? value : ( _.isObject( value ) ? value.fullName : '' ) ),
        map( name => name ? this._filterVicars(name) : this.preachers.slice())
      );
    } );
  }

  displayPreacher( preacher?: IPreacher ): string | undefined {
    return preacher ? preacher.fullName : undefined;
  }

  _filterVicars( value: string ): IPreacher[] {
    let preachers = [];
    if ( !_.isNil( value ) && _.isString( value ) ) {
      const filterValue = value.toLowerCase();
      if ( this.preachers ) {
        preachers = this.preachers.filter( option => option.fullName.toLowerCase().indexOf( filterValue ) !== -1 );
      }
    }
    return preachers;
  }

  filter() {
    this.page = 1;
    console.log( '[DAY-LIST]: Filter' );
    this.fetch();
  }

  togglePlay( $event: IPlayEvent ) {
    console.log( '[DAY-LIST: toggle play]', $event );
    this.currentService = $event.service;
  }

  fetch() {
    console.log( '[DAY-LIST]: Fetch', this.vicarControl );
    this.$lectureService.dispatchDaysAllFetch( {
      page: this.page,
      pageSize: this.pageSize,
      startDate: this.startDate,
      endDate: this.endDate,
      vicarId: this.vicarControl.value ? this.vicarControl.value.id : null,
      organistId: this.selectedOrganist,
      churchId: this.selectedChurch,
      year: this.selectedYear
    } );
  }

  paginate( newPage ) {
    console.log( '[DAY-LIST]: Paginate', newPage );
    this.page = newPage;
    this.fetch();
  }
}



// WEBPACK FOOTER //
// ./src/app/history-list/history-list.component.ts